export const FILTERS = [
  {
    type: 'PRIVATEROOMS',
    key: 'private-room',
    asset: 'door-open',
    transcode_text: 't_TEXTFILTERPRIVATEROOMS',
    transcode_title: 't_TITLEFILTERPRIVATEROOMS',
    transcode_alttext: 't_ALTFILTERPRIVATEROOMS',
    slug: 't_SLUGFILTERPRIVATEROOMS',
  },
  {
    type: 'PARKING',
    key: 'parking',
    asset: 'parking',
    transcode_text: 't_TEXTFILTERPARKING',
    transcode_title: 't_TITLEFILTERPARKING',
    transcode_alttext: 't_ALTFILTERPARKING',
    slug: 't_SLUGFILTERPARKING',
  },
  {
    type: 'COUPLES',
    key: 'couples',
    asset: 'users',
    transcode_text: 't_TEXTFILTERCOUPLES',
    transcode_title: 't_TITLEFILTERCOUPLES',
    transcode_alttext: 't_ALTFILTERCOUPLES',
    slug: 't_SLUGFILTERCOUPLES',
  },
  {
    type: 'FAMILY',
    key: 'families',
    asset: 'children',
    transcode_text: 't_TEXTFILTERFAMILY',
    transcode_title: 't_TITLEFILTERFAMILY',
    transcode_alttext: 't_ALTFILTERFAMILY',
    slug: 't_SLUGFILTERFAMILY',
  },
  {
    type: 'CITYCENTER',
    key: 'city-centre',
    asset: 'map-pin',
    transcode_text: 't_TEXTFILTERCITYCENTER',
    transcode_title: 't_TITLEFILTERCITYCENTER',
    transcode_alttext: 't_ALTFILTERCITYCENTER',
    slug: 't_SLUGFILTERCITYCENTER',
  },
  {
    type: 'KITCHEN',
    key: 'with-kitchen',
    asset: 'utensils',
    transcode_text: 't_TEXTFILTERKITCHEN',
    transcode_title: 't_TITLEFILTERKITCHEN',
    transcode_alttext: 't_ALTFILTERKITCHEN',
    slug: 't_SLUGFILTERKITCHEN',
  },
  {
    type: 'SOLO',
    key: 'solo-travellers',
    asset: 'user-line',
    transcode_text: 't_TEXTFILTERSOLO',
    transcode_title: 't_TITLEFILTERSOLO',
    transcode_alttext: 't_ALTFILTERSOLO',
    slug: 't_SLUGFILTERSOLO',
  },
  {
    type: 'PARTY',
    key: 'fun-party',
    asset: 'nightclub',
    transcode_text: 't_TEXTFILTERPARTY',
    transcode_title: 't_TITLEFILTERPARTY',
    transcode_alttext: 't_ALTFILTERPARTY',
    slug: 't_SLUGFILTERPARTY',
  },
];

export const FILTER_DEFAULT = FILTERS[0];
